import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ParcelaPagamento } from 'src/app/admihair/api/dto/parcela-pagamento';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ParcelaPagamentoService } from 'src/app/admihair/service/parcela-pagamento.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-tipo-pagamento-detalhar',
  templateUrl: './tipo-pagamento-detalhar.component.html',
  styleUrls: ['./tipo-pagamento-detalhar.component.scss']
})
export class TipoPagamentoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  loading: boolean = true;
  id?: number;
  tipoPagamento?: TipoPagamento;
  parcelas: ParcelaPagamento[] = [];

  constructor(private activatedRouter: ActivatedRoute,
    private tipoPagamentoService: TipoPagamentoService,
    private parcelaService: ParcelaPagamentoService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_TIPO_DE_PAGAMENTO');
    this.carregarIdTipoPagamento();
    if (this.permissaoDetalhar) {
      this.carregarTipoPagamento();
    }
  }

  carregarTipoPagamento() {
    this.tipoPagamentoService.buscarPorId(this.id).subscribe({
      next: (data: TipoPagamento) => {
        this.tipoPagamento = data;
        this.carregarParcelas();
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarParcelas() {
    this.parcelaService.listarPorTipoPagamento(this.tipoPagamento?.id).subscribe({
      next: (data: ParcelaPagamento[]) => {
        this.parcelas = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarIdTipoPagamento() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

}
